module.exports = __webpack_public_path__ + "static/media/pricing_vector.28dc4a55.svg";